module.exports = {
frame:{
    left_position: {
        x: 0,
        y: 8
    },
    right_position: {
        x: 151,
        y: 8
    },
    top_position: {
        x: 0,
        y: 0
    },
    bottom_position: {
        x: 0,
        y: 151
    }
}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/frames-config.js
// module id = 19
// module chunks = 0